import React, {
    useContext,
} from "react"

import Modal from "react-bootstrap/Modal"

import {
    Context,
} from "../../../Model/Contexts/AppContext"

import "./style.css"

type EMETLModalProps = {
    children: React.ReactNode,
    modalBodyIDName?: string,
}

const EMETLModal = (props?: EMETLModalProps) => {
    const {
        children,
        modalBodyIDName = "modalContent",
    } = props
    
    const {
        modal: {
            title,
            setTitle,
            setContent,
        },
    } = useContext(Context)

    return (
        <Modal
            show={!!title}
            onHide={() => {
                setContent(null)
                setTitle("")
            }}
        >
            <Modal.Header 
                closeButton 
            >
                <Modal.Title>{title && title}</Modal.Title>
            </Modal.Header>
            <Modal.Body
                id={modalBodyIDName}
            >
                {children}
            </Modal.Body>
        </Modal>
    )
}

export default EMETLModal